import React from 'react'
import Button from "../../atoms/button/button";

import "./Banner-img-txt-btn.scss";

interface BannerImgTxtBtnProps {
    imagenLogo: string;
    tituloBanner: string;
    descripcionBanner: React.ReactNode;
    tituloBotonBanner: string;
    href: string;
}

const BannerImgTxtBtn = ({
    imagenLogo,
    tituloBanner,
    descripcionBanner,
    tituloBotonBanner,
    href
}: BannerImgTxtBtnProps) => {
  return (
    <div
        className="m-banner-img-text-btn"
        style={{ display: "flex" }}
    >
        <div className="m-banner-img-text-btn__imageFixed">
            <img
                src={imagenLogo}
                alt={imagenLogo|| "Imagen"
                }
            />
        </div>
        <div className="m-banner-img-text-btn__description">
            <h3>{tituloBanner}</h3>
            <div className="m-banner-img-text-btn__description__text">
                {descripcionBanner}
            </div>
        </div>
        <div className="m-banner-img-text-btn__buttons">
            <Button
                type="link"
                text={tituloBotonBanner}
                classname={`banner-img-text-btn__button ${tituloBotonBanner}`}
                isDisabled={false}
                href={href}
            /> 
        </div>
    </div>
  )
}

export default BannerImgTxtBtn